import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AppAvatar } from './app-avatar';

export interface CallAnsweredElsewhereNotificationProps {
  receiverName?: string | null;
  receiverAvatarUrl?: string | null;
  callerName?: string | null;
  onClose?: () => void;
}

export function CallAnsweredElsewhereNotification({
  receiverName,
  receiverAvatarUrl,
  callerName,
  onClose,
}: CallAnsweredElsewhereNotificationProps) {
  const { t } = useTranslation();
  const hasNames = !!receiverName && !!callerName;
  const receiverFirstName = receiverName?.split(' ')[0];

  return (
    <div className="flex items-center gap-3 w-full rounded-full border border-emerald-500 bg-emerald-50 py-2 pl-2 pr-4">
      <div className="shrink-0">
        <AppAvatar name={receiverName} src={receiverAvatarUrl} size={32} />
      </div>

      <div className="flex-1 min-w-0">
        {hasNames ? (
          <>
            <div className="text-sm font-semibold text-text-900 leading-tight">
              {t('call_picked_up_title', { receiverName })}
            </div>
            <div className="text-xs text-text-600 leading-tight">
              {t('call_picked_up_subtitle', { receiverName: receiverFirstName, callerName })}
            </div>
          </>
        ) : (
          <div className="text-sm font-semibold text-text-900 leading-tight">{t('call_picked_up_elsewhere')}</div>
        )}
      </div>

      <div className="shrink-0">
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined className="!text-xs" />}
          onClick={onClose}
          className="!w-5 !h-5 !min-w-0 !p-0 !rounded-full !text-text-400 hover:!text-text-900"
        />
      </div>
    </div>
  );
}
